import { Distance, MILES_TO_METERS, getLocaleDistanceUnits } from '.';
import { Locale } from '../internationalization';

const metersToMiles = (meters: number) => {
  const miles = meters / MILES_TO_METERS;
  return Math.round(miles);
};

const metersToKilometers = (meters: number) => Math.round(meters / 1000);

export const getLocaleDistance = (distanceInMeters: number, locale = Locale.DEFAULT_LOCALE) => {
  switch (getLocaleDistanceUnits(locale)) {
    case Distance.MI:
      return metersToMiles(distanceInMeters);
    default:
      return metersToKilometers(distanceInMeters);
  }
};
